import { action, observable } from 'mobx';
import { HttpClient, IConfig, setMap } from 'Mri.Web.Common';

export class InvitesStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadInvitationsAsync(config?: IConfig) {
        const invitations = await this.httpClient.get<Mri.Web.Portal.Controllers.Invites.Invitation[]>(
            '/api/v1/invites',
            config
        );

        setMap(this.invitations, invitations, i => i.invitationId);
    }

    @action
    public async inviteAsync(model: Mri.Web.Portal.Controllers.Invites.AddInviteModel) {
        const invite = await this.httpClient.post<Mri.Web.Portal.Controllers.Invites.Invitation | undefined>(
            '/api/v1/invites',
            model
        );

        if (invite) this.invitations.set(invite.invitationId, invite);
    }

    @action
    public async resendInvite(invitationId: string) {
        const invite = await this.httpClient.post<Mri.Web.Portal.Controllers.Invites.Invitation>(
            `/api/v1/invites/${invitationId}/resend`
        );

        this.invitations.delete(invitationId);
        if (invite) this.invitations.set(invite.invitationId, invite);
    }

    @action
    public async deleteAsync(invitationId: string) {
        await this.httpClient.delete(`/api/v1/invites/${invitationId}`);

        this.invitations.delete(invitationId);
    }

    @action
    public async deleteAllAsync(config?: IConfig) {
        await this.httpClient.delete(`/api/v1/invites`, config);

        await this.loadInvitationsAsync();
    }

    @observable
    public invitations = new Map<string, Mri.Web.Portal.Controllers.Invites.Invitation>();
    private readonly httpClient: HttpClient;
}
